<template>
  <el-cascader style="width: 100%"
               v-model="value"
               :options="options"
               :disabled="showStatus"
               :props="rule"
               @change="handleChange"></el-cascader>
</template>

<script>
import {getCourtTreeArea, getTreeAreaValue} from "@/api/area/area";

export default {
  name: "tripZone",
  data() {
    return {
      options: [],
      rule: {
        value: 'id',
        label: 'name',
      },
      id: '',
      value: [],
    }
  },
  model: {
    prop: 'modelVal',//指向props的参数名
    event: 'modify'//事件名称
  },
  props: {
    modelVal: String,
    showStatus: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    //监听传入的值
    modelVal(val) {
      //判断是否是自己选中的值，自己选的不用执行查询
      if (this.id != val) {
        this.getTreeValue(val);
      }
    }
  },
  created() {
    this.getTreeArea();
    this.getTreeValue(this.modelVal);
  },
  methods: {
    //获取区域树
    getTreeArea() {
      getCourtTreeArea().then(res => {
        if (res.code === '0') {
          this.options = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    //获取选中节点
    getTreeValue(val) {
      if (!val) {
        //如果没有选中值，无需执行查询
        return;
      }
      getTreeAreaValue(val).then(res => {
        if (res.code === '0') {
          if (res.data) {
            this.value = res.data.split(',')
          }
        }
      })
    },

    handleChange(val) {
      //重新抓取值
      if (val && val.length > 0) {
        let id = val[val.length - 1]
        this.id = id;
        this.$emit('modify', id);
        this.$emit('change', id);
      }
      if (!val) {
        this.value = [];
      }
    }
  }
}
</script>

<style scoped>

</style>
